import { Controller } from '@hotwired/stimulus';
import { loadOrgKeyFromStorage, importPublicKey, hybridEncryptOrgKey } from '../vault_crypto';

export default class extends Controller {
  static targets = ['organizationsSelect'];
  static values = { t: Object };

  connect() {
    const el = this.organizationsSelectTarget;
    if (!el.tomselect) {
      this.tomSelectInstance = new TomSelect(el);
    } else {
      this.tomSelectInstance = el.tomselect;
    }
  }

  disconnect() {
    if (this.tomSelectInstance && !this.tomSelectInstance.isDestroyed) {
      this.tomSelectInstance.destroy();
    }
  }

  share(event) {
    event.preventDefault();

    if (window.vault?.is_open()) {
      this.doShare();
    } else {
      window.vault?.openModal(() => this.doShare());
    }
  }

  async doShare() {
    const ts = this.tomSelectInstance;
    const orgList = ts.getValue();

    if (orgList.length === 0) {
      ts.settings.placeholder = this.tValue.select_org_required;
      ts.inputState();
      return;
    }

    try {
      const orgPrivKey = await loadOrgKeyFromStorage();
      const orgPrivBytes = await crypto.subtle.exportKey('pkcs8', orgPrivKey);

      for (const org of orgList) {
        const [id, pkey] = org.split(':');
        if (!pkey) continue;

        const publicKey = await importPublicKey(pkey);
        const sharedKey = `${id}:${await hybridEncryptOrgKey(orgPrivBytes, publicKey)}`;

        const hiddenInput = document.createElement('input');
        hiddenInput.type = 'hidden';
        hiddenInput.name = 'shared_keys_vault[shared_keys][]';
        hiddenInput.value = JSON.stringify({ organization_id: id, shared_key: sharedKey });
        this.element.append(hiddenInput);
      }

      this.organizationsSelectTarget.disabled = true;
      ts.disable();
      this.element.submit();
    } catch (e) {
      console.error('Key sharing failed:', e);
      alert(this.tValue.share_failed);
    }
  }
}
